import {
    createBrowserRouter,
  } from "react-router-dom";
import Home from "../pages/Home";
import RouteWrapper from "./ProtectedRoute";
import AboutUs from "../pages/AboutUs";
import Products from "../pages/Products";
import ContactPage from "../pages/Contact";
  
export const router = createBrowserRouter([
    {
      path: "",
      element: <RouteWrapper />,
      children: [
        {
          path: '',
          index: true,
          element: <Home />
        },
        {
          path: '/home',
          element: <Home />
        },
        {
          path: '/about',
          element: <AboutUs />,
        },
        {
          path: '/products',
          element: <Products />,
        },
        {
          path: "/contact",
          element: <ContactPage />
        }
      ]
    },
  ]);